import { AjaxMethod, AjaxRequest, AjaxResponseType } from "../modules/ajax";
import { Lightbox, LightboxType } from "../modules/lightbox";
export default class Embeds {
    constructor() {
        this.init();
    }
    init() {
        let self = this;
        self.checkRatio();
        window.onresize = () => {
            self.checkRatio();
        };
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        const element = node;
                        if (element.tagName.toLowerCase() === 'iframe' || element.classList.contains('embeditem')) {
                            self.checkRatio();
                        }
                    }
                });
            });
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }
    embed() {
        var embeds = document.querySelectorAll(".embed");
        if (embeds.length > 0) {
            embeds.forEach(embed => {
                let data = JSON.parse(embed.getAttribute("data-options"));
                let holder = embed.querySelector(".holder");
                let anchor = embed.querySelector("a");
                if (anchor != null) {
                    anchor.addEventListener("click", (e) => {
                        e.preventDefault();
                        open(data, holder, anchor);
                    });
                }
                else {
                    open(data, holder, anchor);
                }
            });
        }
        function open(data, holder, anchor) {
            if (data.lightbox) {
                let url = "/Blocks/Embed?" + Object.param({ url: data.url, width: data.width, height: data.height });
                let lightbox = new Lightbox({ disableScrollOnOpen: false, width: data.width, height: data.width, type: LightboxType.AJAX, href: url });
                lightbox.open();
            }
            else {
                let ajax = new AjaxRequest();
                ajax.Send(AjaxMethod.GET, "/Blocks/Embed", { url: data.url, width: data.width, height: data.height }, { ResponseType: AjaxResponseType.TEXT }).then(results => {
                    holder.innerHTML = results.data;
                    holder.classList.remove("hidden");
                    holder.classList.add("open");
                    if (anchor)
                        anchor.remove();
                }, error => {
                });
            }
        }
    }
    checkRatio() {
        var elements = Array.from(document.querySelectorAll(".embeditem"));
        elements.forEach((el) => {
            if (el.hasClass("ratio"))
                return;
            var height = parseInt(el.getAttribute("data-embed-height"), 10);
            var width = parseInt(el.getAttribute("data-embed-width"), 10);
            if (height > 0 && width > 0) {
                var ratio = height / width;
                el.classList.add("ratio");
                el.style.setProperty("--aspect-ratio", Math.round(ratio * 100).toString() + "%");
            }
        });
        var iframes = Array.from(document.querySelectorAll("iframe"));
        iframes.forEach((el) => {
            if (el.hasClass("iframe-ratio"))
                return;
            try {
                var height = parseInt(el.getAttribute("height"), 10);
                var width = parseInt(el.getAttribute("width"), 10);
                if (height > 0 && width > 0) {
                    var ratio = height / width;
                    el.classList.add("iframe-ratio");
                    el.style.setProperty("--aspect-ratio", "1 / " + (Math.round(ratio * 100) / 100).toString());
                }
            }
            catch { }
        });
    }
}
